<div class="container-fluid">
  <div class="row">
    <div class="card shadow-sm p-0">

      <div class="card-header">
        <h3 class="card-title">Set Opening and Closing Hours</h3>
      </div>

      <div class="card-body">
        @if (alertInfo.show) {
          <ngb-alert [type]="alertInfo.type" (closed)="alertInfo.show = false">
            {{ alertInfo.message }}
          </ngb-alert>
        }

        @if (form) {
          <form [formGroup]="form">
            <div class="row g-3">
              <div class="col-sm-6 mt-2">
                <input-field
                  label="Opening Time"
                  type="time"
                  [inputFormControl]="openingTimeControl"
                />
              </div>
              <div class="col-sm-6 mt-2">
                <input-field
                  label="Closing Time"
                  type="time"
                  [inputFormControl]="closingTimeControl"
                />
              </div>
            </div>

            <div class="text-center mt-4">
              <button type="button" class="btn btn-primary me-4 px-4 py-2" (click)="cancel()">Cancel</button>
              <button type="button" class="btn btn-success px-4 py-2" (click)="save()">Save</button>
            </div>
          </form>
        }
      </div>

    </div>
  </div>
</div>

